<template>
  <div class="allapps">
    <div class="allapps_top">
      <div class="allapps_top_box">
        <div class="allapps_top_title">All apps in Salesdish</div>
        <div class="allapps_top_subtitle">
          We are committed to a truly useful and simple operation of One-stop
          apps integration.
        </div>
        <div class="allapps_top_shadow">
          <div class="allapps_top_subtitle2">
            Not sure which apps to choose? Our team is always ready to support!
          </div>
          <div class="allapps_top_content">
            <img src="../assets/allapp2.svg" alt=""  @click="changeRouter('/home')">
            <div class="allapps_top_content_button" @click="liveChat">
              Live Chat
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="allapps_tab">
      <div class="allapps_tab_box">
        <div class="allapps_tab_top">
          <div class="allapps_tab_tabs">
            <div
              v-for="item in tab_content"
              :key="item.tab_id"
              :class="
                tabid == item.tab_id
                  ? 'allapps_tab_tabs_title allapps_tab_tabs_active'
                  : 'allapps_tab_tabs_title'
              "
              @click="changeTab(item.tab_id)"
            >
              {{ item.tab_name }}
            </div>
          </div>
          <div class="allapps_tab_line"></div>
          <div
            :class="
              tabid
                ? `allapps_tab_active allapps_tab_active${tabid}`
                : 'allapps_tab_active'
            "
          ></div>
        </div>
      </div>
    </div>

    <div class="allapps_content">
      <div class="allapps_content_box">
        <div v-if="tabid == 1" class="allapps_content_app">
          <div
            v-for="(item, index) in allapp_data"
            :key="index"
            class="allapps_content_app_category"
          >
            <div class="allapps_content_app_category_name">
              {{ item.category_name }}
            </div>
            <div class="allapps_content_app_category_app">
              <div
                v-for="(app, count) in item.app_data"
                :key="count"
                :class="
                  count % 3 == 0
                    ? 'allapps_content_app_category_app_box'
                    : 'allapps_content_app_category_app_box allapps_content_app_category_app_box1'
                "
              >
                <img :src="app.img" />
                <div class="allapps_content_app_category_app_name">
                  {{ app.app_name }}
                </div>
                <div class="allapps_content_app_category_app_content">
                  {{ app.app_content }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="allapps_content_development">
          <div
            v-for="(item, index) in development_data"
            :key="index"
            :class="
              index % 3 == 0
                ? 'allapps_content_development_box'
                : 'allapps_content_development_box allapps_content_development_box1'
            "
          >
            <img :src="item.img" />
            <div class="allapps_content_app_category_app_name">
              {{ item.app_name }}
            </div>
            <div class="allapps_content_app_category_app_content">
              {{ item.app_content }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="allapps_install">
      <div class="allapps_install_box">
        <div class="allapps_install_content">
          <div class="allapps_install_text">
            <div class="allapps_install_title">
              Install Salesdish.<br />
              Unlimited possibilities for your store.
            </div>
            <div class="allapps_install_subtitle">
              The installation is a one click process and is super easy to get
              up and running quickly!
            </div>
          </div>
          <div class="allapps_install_button">
            <div
              class="allapps_install_button_text"
              @click="goLink('https://apps.shopify.com/salesdish')"
            >
              Start your 14-day free trial
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./common/header.vue";
import Footer from "./common/footer.vue";

export default {
  name: "Allapps",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      tab_content: [
        {
          tab_id: 1,
          tab_name: "All apps",
        },
        {
          tab_id: 2,
          tab_name: "In development",
        },
      ],
      allapp_data: [],
      development_data: [],
      obj: {
        category_name: "",
        app_data: [],
      },
      tabid: 1,
      ispc:true
    };
  },
  methods: {
    changeTab(tab_id) {
      this.tabid = tab_id;
    },
    changeRouter(link) {
      this.$router
        .push({
          path: link,
        })
        .catch((err) => {
          // console.log('e',err)
        });
    },
    liveChat() {
      if (window.fcWidget) {
        window.fcWidget.open();
      }
    },
    getData() {
      this.$axios
        .get(
          `https://gateway.salesdish.com/shopify-service/app-tools/pass/apps/1100`
        )
        .then((res) => {
          // console.log(res);
          for (let i = 1; i < res.data.list.length; i++) {
            if (res.data.list[i].enabled == true) {
              this.obj.category_name = res.data.list[i].name;
              res.data.list[i].children.forEach((value) => {
                var item = new Object();
                item.app_name = value.name;
                item.app_content = value.introduce;
                if (value.enabled == true || value.id === 36427) {
                  try {
                    item.img = require(`../assets/antools_app_icon${value.id}.svg`);
                    this.obj.app_data.push(item);
                  } catch (error) {
                    // console.log("Image lost:" + value.id);
                    item.img = require(`../assets/antools_app_icon_default.svg`);
                    this.obj.app_data.push(item);
                  }
                } else if (value.introduce != undefined) {
                  // console.log("Image dev:" + value.id);
                  item.img = require(`../assets/antools_app_icon_default.svg`);
                  this.development_data.push(item);
                }
              });
              this.allapp_data.push(this.obj);
              this.obj = {
                category_name: "",
                app_data: [],
              };
            } else {
              res.data.list[i].children.forEach((value) => {
                if (value.introduce != undefined) {
                  var item = new Object();
                  item.app_name = value.name;
                  item.app_content = value.introduce;
                  item.img = require(`../assets/antools_app_icon_default.svg`);
                  this.development_data.push(item);
                }
              });
            }
          }
          // console.log(typeof this.allapp_data[0]);
        });
    },
    goLink(url) {
      window.open(url);
    },
  },
  created() {
    this.getData();
    if(document.body.offsetWidth>767){
      this.ispc=true
    }else{
      this.ispc=false
    }
  },
};
</script>

<style scoped>
.allapps_top {
  background: url(../assets/allapps_background.svg);
  height: 512px;
  background-size: cover;
  background-position: center;
}
.allapps_top_box {
  width: 1200px;
  margin: auto;
}
.allapps_top_title {
  font-size: 40px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  text-align: center;
  padding: 139px 0 20px;
}
.allapps_top_subtitle {
  font-size: 24px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #222536;
  line-height: 40px;
  text-align: center;
  margin-bottom: 57px;
}
.allapps_top_shadow {
  width: 1024px;
  height: 172px;
  background: #01c4c714;
  border-radius: 20px;
  /* opacity: 0.08; */
  margin-left: 88px;
  padding-top: 26px;
}
.allapps_top_subtitle2 {
  font-size: 24px;
  font-family: Helvetica-Medium, Helvetica;
  font-weight: 600;
  color: #222536;
  line-height: 40px;
  text-align: center;
  margin-bottom: 14px;
}
.allapps_top_content {
  display: flex;
 justify-content: center;
}
.allapps_top_content img {
  cursor: pointer;
  margin-right: 50px;
}
.allapps_top_content_text {
  margin: 14px 50px 0 10px;
  cursor: pointer;
}
.allapps_top_content_text img {
  margin-bottom: 8px;
  cursor: pointer;
}
.allapps_top_content_text_2 {
  font-size: 14px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #0c0546;
  line-height: 20px;
}
.allapps_top_content_button {
  width: 127px;
  height: 50px;
  box-shadow: 0px 6px 8px 0px rgba(1, 196, 199, 0.1);
  border-radius: 4px;
  border: 2px solid #01c4c7;
  text-align: center;
  line-height: 46px;
  font-size: 18px;
  font-family: Helvetica-Medium, Helvetica;
  font-weight: 500;
  color: #01c4c7;
  margin-top: 12px;
  cursor: pointer;
}
.allapps_tab {
  background-color: #f9fbff;
}
.allapps_tab_box {
  width: 1200px;
  height: 100px;
  margin: auto;
}
.allapps_tab_tabs {
  display: flex;
  text-align: center;
}
.allapps_tab_tabs_title {
  height: 40px;
  font-size: 16px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #222536;
  line-height: 40px;
  cursor: pointer;
  margin: 48px 0 7px 32px;
}
.allapps_tab_tabs_active {
  height: 40px;
  font-size: 16px;
  font-family: Helvetica;
  color: #01c4c7;
  line-height: 40px;
  cursor: pointer;
}
.allapps_tab_active {
  height: 4px;
  background: #01c4c7;
  border-radius: 3px;
}
.allapps_tab_active1 {
  width: 57px;
  margin-left: 32px;
}
.allapps_tab_active2 {
  width: 110px;
  margin-left: 121px;
}
.allapps_tab_line {
  width: 1200px;
  /* height: 1px; */
  border-bottom: 1px solid rgba(151, 151, 151, 0.3);
  margin-bottom: -4px;
}
.allapps_content {
  background: #f9fbff;
  padding-bottom: 80px;
}
.allapps_content_box {
  width: 1200px;
  margin: auto;
}
.allapps_content_app_category {
  padding-top: 60px;
}
.allapps_content_app_category_name {
  height: 40px;
  font-size: 32px;
  font-family: Helvetica-Medium, Helvetica;
  font-weight: 600;
  color: #222536;
  line-height: 40px;
  margin-bottom: 15px;
}
.allapps_content_app_category_app {
  display: flex;
  flex-wrap: wrap;
}
.allapps_content_app_category_app_box {
  width: 386px;
  height: 325px;
  background: #ffffff;
  box-shadow: 0px 5px 4px 0px rgba(167, 167, 167, 0.08);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
}
.allapps_content_app_category_app_box:hover {
  box-shadow: 0 0.1rem 0.08rem 0 rgba(156, 156, 156, 0.22),
    0 0.05rem 0.04rem 0 rgba(167, 167, 167, 0.06);
}
.allapps_content_app_category_app_box1 {
  margin-left: 21px;
}
.allapps_content_app_category_app_box img {
  margin-top: 30px;
  height: 122px;
}
.allapps_content_app_category_app_name {
  height: 28px;
  font-size: 20px;
  font-family: Helvetica-Medium, Helvetica;
  font-weight: 600;
  color: #222536;
  line-height: 28px;
  text-align: center;
  margin-top: 18px;
}
.allapps_content_app_category_app_content {
  width: 352px;
  font-size: 16px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #8d919b;
  line-height: 24px;
  text-align: center;
  margin-top: 18px;
}
.allapps_content_development {
  display: flex;
  flex-wrap: wrap;
  padding-top: 30px;
}
.allapps_content_development_box {
  width: 386px;
  height: 325px;
  background: #ffffff;
  box-shadow: 0px 5px 4px 0px rgba(167, 167, 167, 0.08);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
}
.allapps_content_development_box:hover {
  box-shadow: 0 0.1rem 0.08rem 0 rgba(156, 156, 156, 0.22),
    0 0.05rem 0.04rem 0 rgba(167, 167, 167, 0.06);
}
.allapps_content_development_box1 {
  margin-left: 21px;
}
.allapps_content_development_box img {
  margin-top: 30px;
  height: 122px;
}
.allapps_install {
  background: #ffffff;
  height: 342px;
}
.allapps_install_box {
  width: 1200px;
  margin: auto;
}
.allapps_install_content {
  display: flex;
  justify-content: space-between;
}
.allapps_install_text {
  margin-top: 90px;
}
.allapps_install_title {
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
}
.allapps_install_subtitle {
  width: 681px;
  font-size: 24px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #222536;
  line-height: 28px;
  padding-top: 25px;
}
.allapps_install_button {
  width: 259px;
  height: 50px;
  background: #01c4c7;
  box-shadow: 0px 6px 8px 0px rgba(1, 196, 199, 0.1);
  border-radius: 4px;
  text-align: center;
  line-height: 50px;
  margin-top: 90px;
  cursor: pointer;
}
.allapps_install_button_text {
  height: 20px;
  font-size: 18px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #ffffff;
}
@media (max-width: 767px) {
  .allapps{
    margin-top:.96rem
  }
  .allapps_top {
    height: auto;
    width: 100%;
    padding:0 0 0.44rem;
    background: url(../assets/allapp.svg);
  }
  .allapps_top_box {
    width: 100%;
    margin: auto;
    padding: 1.14rem 0.48rem 0;
  }
  .allapps_top_title {
    font-size: .48rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: 700;
    color: #222536;
    line-height: .6rem;
    padding: 0;
  }
  .allapps_top_subtitle {
    font-size: .24rem;
    line-height: .36rem;
    margin: .28rem auto .6rem;
    opacity: .6;
  }
  .allapps_top_shadow {
    width: 100%;
    height: auto;
    border-radius: .2rem;
    margin-left: 0;
    padding:.36rem 0rem;
  }
  .allapps_top_subtitle2 {
    width: 3.91rem;
    font-size: .24rem;
    font-weight: 400;
    line-height: .36rem;
    margin:0 auto .2rem;
  }
  .allapps_top_content {
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
  .allapps_top_content img {
    width: 2.6rem;
    height: .72rem;
    margin-right: .5rem;
  }
  .allapps_top_content_button {
    width: 1.27rem;
    height: .5rem;
    box-shadow: 0px .06rem .08rem 0px rgba(1, 196, 199, 0.1);
    border-radius: .04rem;
    border: 2px solid #01c4c7;
    line-height: .5rem;
    font-size: .18rem;
    text-align: center;
    margin-top: 0;
  }
  .allapps_tab_box {
    width: 100%;
    height: auto;
    padding: .6rem .48rem .48rem;
  }
  .allapps_tab_tabs_title {
    font-size: .28rem;
    opacity: .6;
    color: #222536;
    letter-spacing: 0;
    line-height: .4rem;
    font-weight: 400;
    margin: 0 .48rem .1rem 0;
    height: .4rem;
  }
  .allapps_tab_tabs_active {
    color: #01C4C7;
  }
  .allapps_tab_active {
    height: .04rem;
    border-radius: .03rem;
  }
  .allapps_tab_active1 {
    width: 1rem;
    margin-left: 0;
  }
  .allapps_tab_active2 {
    width: 1.92rem;
    margin-left: 1.48rem;
  }
  .allapps_tab_line {
    width: 100%;
    /* height: 1px; */
    border-bottom: 1px solid rgba(151, 151, 151, 0.3);
    margin-bottom: -.04rem;
  }
  .allapps_content {
    background: #f9fbff;
    padding-bottom: 0;
  }
  .allapps_content_box {
    width: 100%;
    margin: auto;
    padding: 0 .48rem .2rem;
  }
  .allapps_content_app_category {
    padding-top: 0;
  }
  .allapps_content_app_category_name {
    height: auto;
    font-size: .32rem;
    font-weight: 400;
    line-height: .4rem;
    margin-bottom: .32rem;
  }
  .allapps_content_app_category_app {
    margin-bottom: .32rem;
  }
  .allapps_content_app_category_app_box {
    width: 100%;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 0 .24rem 0px rgba(167, 167, 167, 0.08);
    border-radius: .24rem;
    margin-bottom: .28rem;
    margin-top: 0;
    padding: .58rem .48rem;
    min-height: 5.18rem;
  }
  .allapps_content_app_category_app_box:hover {
    box-shadow: 0 0.1rem 0.08rem 0 rgba(156, 156, 156, 0.22),
      0 0.05rem 0.04rem 0 rgba(167, 167, 167, 0.06);
  }
  .allapps_content_app_category_app_box1 {
    margin-left: 0;
  }
  .allapps_content_app_category_app_box img {
    margin-top: 0;
    height: 2rem;
    width: 2rem;
  }
  .allapps_content_app_category_app_name {
    height: auto;
    font-size: .36rem;
    font-weight: 700;
    line-height: .28rem;
    margin-top: .4rem;
  }
  .allapps_content_app_category_app_content {
    width: 100%;
    font-size: .28rem;
    line-height: .38rem;
    margin-top: .2rem;
  }
  .allapps_content_development {
    display: flex;
    flex-wrap: wrap;
    padding-top: 0;
    margin-bottom: 0.32rem
  }
  .allapps_content_development_box {
    width: 100%;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 0 .24rem 0px rgba(167, 167, 167, 0.08);
    border-radius: .24rem;
    margin-bottom: .28rem;
    margin-top: 0;
    padding: .58rem .48rem;
    min-height: 5.18rem;
  }
  .allapps_content_development_box:hover {
    box-shadow: 0 0.1rem 0.08rem 0 rgba(156, 156, 156, 0.22),
      0 0.05rem 0.04rem 0 rgba(167, 167, 167, 0.06);
  }
  .allapps_content_development_box1 {
    margin-left: 0;
  }
  .allapps_content_development_box img {
    margin-top: 0;
    height: 2rem;
    width: 2rem;
  }
  .allapps_install {
    background: #ffffff;
    height: auto;
  }
  .allapps_install_box {
    width: 100%;
    margin: auto;
    padding: .8rem .48rem 1rem;
  }
  .allapps_install_content {
    display: block;
  }
  .allapps_install_text {
    margin-top: 0;
  }
  .allapps_install_title {
    font-size: .48rem;
    font-weight: 700;
    line-height: .58rem;
    text-align: center;
  }
  .allapps_install_subtitle {
    width: auto;
    font-size: .24rem;
    line-height: .36rem;
    padding-top: .24rem;
    padding-bottom: .4rem;
    text-align: center;
  }
  .allapps_install_button {
    width: 3.38rem;
    height: .56rem;
    background: #01c4c7;
    box-shadow: 0px .06rem .08rem 0px rgba(1, 196, 199, 0.1);
    border-radius: .04rem;
    text-align: center;
    line-height: .56rem;
    margin: 0 auto;
  }
  .allapps_install_button_text {
    height: auto;
    font-size: .18rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/allapp.vue